import TableCell from "@mui/material/TableCell";

import { BoxHeadTableCell } from "./HeadTableCell.styled";

const HeadTableCell = ({ children }) => {
  return (
    <TableCell>
      <BoxHeadTableCell>{children}</BoxHeadTableCell>
    </TableCell>
  );
};

export default HeadTableCell;
